<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" /> Service Question Form Data Loading...
  </div>
  <div v-else class="animated fadeIn">
    <basic-heading :title="title" class="mb-3">
      <template #right-content>
        <header-button-group :button_config="button_config" />
      </template>
    </basic-heading>
    <service-question-form
      :laboratory="laboratory"
      :sample_type="sample_type"
      @submit="submit"
    />
  </div>
</template>

<script>
import Vue from "vue";
import VueNotifications from "vue-notifications";
import BasicHeading from "@/components/shared/BasicHeading";
import HeaderButtonGroup from "@/components/shared/headerbuttons/HeaderButtonGroup";
import ServiceQuestionForm from "@/components/lab/servicequestion/ServiceQuestionForm";
import { notificationOptions } from "@/shared/toast-notification-options";
import { serviceQuestionNotifications } from "@/shared/notifications";
import { LabRepositoryFactory } from "@/repositories/lab/LabRepositoryFactory";
import { getModel } from "@/shared/fetch-utils";

const ServiceQuestionRepository = LabRepositoryFactory.get("serviceQuestion");

Vue.use(VueNotifications, notificationOptions);

export default {
  name: "ServiceQuestionEdit",
  components: {
    BasicHeading,
    ServiceQuestionForm,
    HeaderButtonGroup,
  },
  data() {
    return {
      loading: true,
      laboratory_id: this.$route.params.laboratory_id || null,
      laboratory: null,
      sample_type_id: this.$route.params.sample_type_id || null,
      sample_type: null,
    };
  },
  computed: {
    button_config() {
      return {
        buttons: [
          {
            icon: "fa-arrow-left",
            linkto: "/sampletypes/" + this.sample_type_id + "",
            title: "Back to service question",
          },
        ],
      };
    },
    title() {
      return this.sample_type
        ? `Update ${this.sample_type.name} Questions`
        : "Update Service Questions";
    },
  },
  methods: {
    async init() {
      this.sample_type = await getModel({
        model_type: "sample_type",
        id: this.sample_type_id,
        message: this.$bvToast,
      });
      this.laboratory = await getModel({
        model_type: "laboratory",
        id: this.laboratory_id,
        message: this.$bvToast,
      });

      this.loading = false;
    },
    submit(payload) {
      let this_obj = this;

      let default_data = {
        laboratory_id: this.laboratory_id,
        sample_type_id: this.sample_type_id,
      };

      Object.keys(payload).forEach(function (form_level) {
        Object.assign(default_data, { form_level: form_level });

        for (let i = 0; i < payload[form_level].length; i++) {
          let question_data = payload[form_level][i];

          if (
            typeof question_data.input_type === "undefined" ||
            typeof question_data.label === "undefined"
          ) {
            continue;
          }

          Object.assign(question_data, default_data);

          if (
            typeof question_data.id !== "undefined" &&
            question_data.id.length
          ) {
            this_obj.updateQuestion(question_data);
          } else {
            this_obj.createQuestion(question_data);
          }
        }
      });
    },
    createQuestion(payload) {
      return ServiceQuestionRepository.create(payload)
        .then((response) => {
          if (response && response.status === 201 && response.data) {
            this.addSuccess();
          } else {
            this.addFail();
          }
        })
        .catch(() => {
          this.addFail();
        });
    },
    updateQuestion(payload) {
      return ServiceQuestionRepository.update(payload.id, payload)
        .then((response) => {
          if (response && response.status === 200 && response.data) {
            this.editSuccess();
          } else {
            this.editFail();
          }
        })
        .catch(() => {
          this.editFail();
        });
    },
  },
  created() {
    this.loading = true;

    this.init();
  },
  notifications: serviceQuestionNotifications,
};
</script>
